<template>
  <label ref="label"
         class="d-checkbox checkbox"
         :class="[size, { 'is-disabled': disabled }]"
         :disabled="disabled"
         :tabindex="disabled ? false : 0"
         @keydown.prevent.enter.space="$refs.label.click()"
  >
    <input v-model="computedValue"
           tabindex="-1"
           :indeterminate.prop="indeterminate"
           type="checkbox"
           :disabled="disabled"
           :required="required"
           :name="name"
           :value="nativeValue"
           :true-value="trueValue"
           :false-value="falseValue"
           @click.stop
    >
    <span class="check" :class="[newCheckClass]">
      <span class="checkmark" :class="[newCheckMarkClass]" />
    </span>
    <span class="control-label">
      <slot /></span>
  </label>
</template>

<script>
  /**
   * @displayName DCheckbox
   */
  export default {
    name: 'DCheckbox',
    props: {
      /**
       * @ignore
       */
      value: [String, Number, Boolean, Function, Object, Array, Symbol],

      /**
       * @ignore
       */
      name: String,

      /**
       * @ignore
       */
      disabled: Boolean,

      /**
       * @ignore
       */
      required: Boolean,

      /**
       * Directly alter the value of the native checkbox. Same as native `value`
       */
      nativeValue: {
        type: [String, Number, Boolean, Function, Object, Array, Symbol],
        default: null,
      },

      /**
       * Same as native `indeterminate`
       */
      indeterminate: Boolean,

      /**
       * Use a pre-defined color
       * (`primary-500`, etc)
       */
      color: {
        type: String,
        default: 'primary-500',
      },
      size: String,

      /**
       * Overrides the returned value when it's checked
       */
      trueValue: {
        type: [String, Number, Boolean, Function, Object, Array, Symbol],
        default: true,
      },

      /**
       * Overrides the returned value when it's not checked
       */
      falseValue: {
        type: [String, Number, Boolean, Function, Object, Array, Symbol],
        default: false,
      },
    },
    data() {
      return {
        newValue: this.value,
      };
    },
    computed: {
      computedValue: {
        get() {
          return this.newValue;
        },

        set(value) {
          this.newValue = value;
          this.$emit('input', value);
        },
      },

      newCheckClass() {
        return {
          [`check--${this.color}`]: this.getSingleValue(),
          checked: this.getSingleValue(),
        };
      },

      newCheckMarkClass() {
        return {
          [`checkmark--${this.color}`]: this.getSingleValue(),
        };
      },
    },

    watch: {
      /**
       * When v-model change, set internal value.
       */
      value(value) {
        this.newValue = value;
      },
    },

    methods: {
      getSingleValue() {
        if (typeof this.computedValue === 'object' && Object.keys(this.computedValue).length > 0) {
          return this.computedValue.includes(this.nativeValue);
        }

        if (this.nativeValue) {
          return this.computedValue === this.nativeValue;
        }

        return this.computedValue === this.trueValue;
      },
    },
  };
</script>